import React from 'react';
import { useBookingData } from '../../context/BookingContext';

const CasualConditions = () => {

    const { booking } = useBookingData();
    const surcharge = booking?.surcharge || 0;


    return (
        <div className="px-4 py-4 sm:px-6 sm:py-6 w-full sm:w-96">
            <div className="text-gray-800 font-medium">
                Note
            </div>
            <p className="text-gray-700 text-sm">
                Please ensure the bins are placed in the designated collection point
                the evening before the removal/exchange date. See bin placements for details.
                A return trip will incur a surchage of ${surcharge}+gst.
            </p>
            <p>
                <br/>
            </p>
            <p className="text-gray-700 text-sm">
                To ensure your booking is organised in a timely manner, please accept the booking
                before 12pm the day prior to the first scheduled delivery date.
            </p>
        </div>
    )
}

export default CasualConditions;
